var version = '6.6.1';

module.exports = version;
